import {LitElement, html, css} from 'lit';
import {customElement, property} from 'lit/decorators.js';
import global_css from './global-css';

@customElement('ri-modal')
export class Modal extends LitElement {
  static override styles = [
    global_css,
    css`
      .overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 1001;
      }
      .modal {
        position: fixed;
        top: 0;
        left: 0;
        /* transform: translate(-50%, -50%); */
        width: 100vw;
        height: 100vh;
        background-color: rgb(var(--background-color, 255, 255, 255));
        border-radius: 5px;
        z-index: 1002;
      }
    `,
  ];

  constructor() {
    super();
    this.hidden = !this.active;
  }

  @property({type: Boolean, reflect: true}) active = false;
  @property({type: Boolean}) closeOnOverlay = false;

  override render() {
    return html`
      <div
        class="overlay"
        @click=${this.closeOnOverlay ? this.close : null}
      ></div>
      <div class="modal">
        <slot></slot>
      </div>
    `;
  }

  open() {
    this.active = true;
    this.hidden = false;
  }

  close() {
    this.active = false;
    this.hidden = true;
    this.onClose();
  }

  onClose() {}
}
